import { render } from "./VUEPopupDatiAssistenza.vue?vue&type=template&id=0ea09e19&scoped=true"
import script from "./VUEPopupDatiAssistenza.vue?vue&type=script&lang=js"
export * from "./VUEPopupDatiAssistenza.vue?vue&type=script&lang=js"

import "./VUEPopupDatiAssistenza.vue?vue&type=style&index=0&id=0ea09e19&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea09e19"]])

export default __exports__